import axios from 'axios';
import state from './state'
import cache from './cache'
import { MessageBox } from 'element-ui';

let token = ''
    //添加请求拦截器
axios.interceptors.request.use(
    config => {
        //在发送请求之前做些什么
        token = localStorage.getItem("token")
            // console.log(state.ip)
        if (token != '') { // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = token;
            // config.headers.Authorization = '';
            // config.headers.Authorization = 'JWT eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMTAwMDEiLCJ1c2VybmFtZSI6IjE1MDcxMDU1NTAzIiwiZXhwIjoxNTY5MTIzOTk3fQ.4koyFrXcmIb2BJuXsNCqvVrV_ZkBPpz8qr9eLVXeMNg'
        }
        return config;
    },
    err => {
        //对响应错误做什么
        //console.log(err)
        return Promise.reject(err);
    })


//添加响应拦截器
axios.interceptors.response.use(
    response => {
        //console.log(111)
        return response
    },
    error => {
        console.log(error)
        if (error.response.status == 401) {
            //console.log(error.response.status)
            MessageBox.alert('登录信息超时，请重新登录！', '登录超时', {
                confirmButtonText: '跳转登录页面',
                callback: action => {
                    localStorage.clear();
                    window.location.href = '#/login';
                }
            })
        }
        return Promise.reject(error)
    }
)

export default {
    /*获取Banner列表(缓存) */
    async get_banners_list({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/bannersList',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*获取学校信息资料(缓存) */
    async get_school_information({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/school',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*获取老师信息资料(缓存) */
    async get_teachers_information({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/teachers',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

    /*获取老师详细(缓存) */
    async get_teachers_detail({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/teacherDetail',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*获取新闻信息(缓存) */
    async get_news_information({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/news',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*获取新闻详情(缓存) */
    async get_news_detail({ commit, state }, params) {
        return await axios({
            url: state.ip + 'show/newsDetail',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*获取公开课列表(缓存) */
    async get_open_class_list({ commit, state }, params) {
        return await axios({
            url: state.ip + 'course/openClass',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*获取线下课程列表(缓存) */
    async get_course_list({ commit, state }, params) {
        return await axios({
            url: state.ip + 'course/courseList',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*获取线下课程详情(缓存) */
    async get_course_detail({ commit, state }, params) {
        return await axios({
            url: state.ip + 'course/courseDetail',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*获取推荐线下课程列表(缓存) */
    async get_recommend_course({ commit, state }, params) {
        return await axios({
            url: state.ip + 'course/recommendCourseList',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*新增线下课程报名信息 */
    postEnterCourse({ commit, state }, params) {
        return axios({
            url: state.ip + "course/enterCourse/",
            method: 'post',
            data: params,
        });
    },

    /*获取七牛云token */
    get_qiniu_token({ commit, state }, params) {
        return axios({
            url: state.ip + 'users/get_qiniu_token',
            method: 'get',
            params,
        });
    },
    /*登录页*/
    //发送短信验证码
    sendCode({ commit, state }, params) {
        return axios({
            url: state.ip + 'users/code',
            method: 'get',
            params,
        });
    },

    //登录系统
    doLogin({ commit, state }, params) {
        return axios({
            url: state.ip + 'users/dologin/',
            method: 'post',
            data: params,
        });
    },


    /*用户管理*/
    //查
    userData({ commit, state }, params) {
        return axios({
            url: state.ip + "users/data/" + params.UserID + '/',
            method: 'get',
            params: params,
        });
    },
    //查(缓存)
    async userDataCache({ commit, state }, params) {
        return await axios({
            url: state.ip + "users/data/" + params.UserID + '/',
            method: 'get',
            params: params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    //增
    addUserData(params) {
        return axios({
            url: urltit + "users/",
            method: 'post',
            data: params,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    //改
    updateUserData({ commit, state }, params) {
        return axios({
            url: state.ip + "users/update/" + params.UserID + '/',
            method: 'PATCH',
            data: params,
        });
    },

    /* 学员管理*/
    //增
    addBabyData({ commit, state }, params) {
        return axios({
            url: state.ip + "users/update_baby/",
            method: 'post',
            data: params,
        });
    },
    //改
    updateBabyData({ commit, state }, params) {
        return axios({
            url: state.ip + "users/update_baby/" + params.BabyID + '/',
            method: 'PATCH',
            data: params,
        });
    },
    //删
    deleteBabyData({ commit, state }, params) {
        return axios({
            url: state.ip + "users/delete_baby/" + params.BabyID + '/',
            method: 'PATCH',
            data: params,
        });
    },
    //查 带缓存
    async getBabyDataCache({ commit, state }, params) {
        return await axios({
            url: state.ip + "users/update_baby/" + params.BabyID + '/',
            method: 'get',
            params: params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    //查 
    getBabyData({ commit, state }, params) {
        return axios({
            url: state.ip + "users/update_baby/" + params.BabyID + '/',
            method: 'get',
            params: params,
        });
    },

    /* 成长记录管理 */
    //新增成长记录
    addGrowUp({ commit, state }, params) {
        return axios({
            url: state.ip + "users/add_grow_up/",
            method: 'post',
            data: params,
        });
    },

    //查看成长记录
    getGrowUp({ commit, state }, params) {
        return axios({
            url: state.ip + "users/add_grow_up/",
            method: 'get',
            params: params,
        });
    },

    //小明星广场查看成长记录
    getPublicGrowUp({ commit, state }, params) {
        return axios({
            url: state.ip + "users/stars_grow_up/",
            method: 'get',
            params: params,
        });
    },

    //小明星广场点赞成长记录
    postLikeGrowUp({ commit, state }, params) {
        return axios({
            url: state.ip + "users/like_grow_up/",
            method: 'post',
            data: params,
        });
    },

    //删除成长记录
    deleteGrowUp({ commit, state }, id) {
        return axios({
            url: state.ip + "users/add_grow_up/" + id + '/',
            method: 'delete',
            data: id,
        });
    },

    //删除成长记录图片
    deleteGrowUpImg({ commit, state }, params) {
        return axios({
            url: state.ip + "users/delete_grow_up_img",
            method: 'post',
            data: params,
            headers: {
                'Content-Type': 'x-www-form-urlencoded'
            }
        });
    },
    //批量删除七牛云图片
    delete_qiniu_imgs({ commit, state }, params) {
        return axios({
            url: state.ip + "users/delete_qiniu_imgs",
            method: 'post',
            data: params,
            headers: {
                'Content-Type': 'x-www-form-urlencoded'
            }
        });
    },

    //小小剧场
    //获取所有小小剧场列表
    async getStageListCache({ commit, state }, params) {
        return await axios({
            url: state.ip + "stage/stageList/",
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    //获取小小剧场详情

    /*获取小小剧场详情(缓存) */
    async get_stage_detail({ commit, state }, params) {
        return await axios({
            url: state.ip + 'stage/stageDetails',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*获取更多推荐视频(缓存) */
    async get_more_stage({ commit, state }, params) {
        return await axios({
            url: state.ip + 'stage/otherStageVideo',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*点赞小小剧场 */
    postLikeStageVideo({ commit, state }, params) {
        return axios({
            url: state.ip + "stage/likeStageVideo/",
            method: 'post',
            data: params,
        });
    },
    /*评论小小剧场 */
    postCommentStageVideo({ commit, state }, params) {
        return axios({
            url: state.ip + "stage/commentStageVideo/",
            method: 'post',
            data: params,
        });
    },
    
    /*通过学员ID获取学员详细资料*/
    async get_baby_user({ commit, state }, params) {
        return await axios({
            url: state.ip + 'users/baby_id',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },

     /*通过活动ID获取活动详情*/
     async get_activity_detail({ commit, state }, params) {
        return await axios({
            url: state.ip + 'activity/activityDetail/',
            method: 'get',
            params,
            adapter: cache({
                local: false // 是否永久保留在本地，默认为false
            })
        });
    },
    /*通过活动ID增加点击量*/
    update_activity_clickNum({ commit, state }, params) {
        return axios({
            url: state.ip + "activity/activityDetail/" + params.id + '/',
            method: 'PATCH',
            data: params,
        });
    },
    /*通过活动ID增加转发量*/
    update_activity_shareNum({ commit, state }, params) {
        return axios({
            url: state.ip + "activity/activityDetail/" + params.id + '/',
            method: 'PATCH',
            data: params,
        });
    },
    /*通过活动ID增加报名数*/
    update_activity_enterNum({ commit, state }, params) {
        return axios({
            url: state.ip + "activity/activityDetail/" + params.id + '/',
            method: 'PATCH',
            data: params,
        });
    },
}


// WEBPACK FOOTER //
// ./src/store/actions.js